// extracted by mini-css-extract-plugin
export default {"textArea":"UBUenTZUh8VZ7iejjIRD","textAreaWrapper":"VnNdFPQkIMkg2XzQNm9N","additionalWrapper":"brsmql059_BW02mCKQew","disabled":"sVhapcB4rAcPZEO37swS","error":"_U7xKh8eq3Vd3fIBIEw3"};